import * as React from 'react'

import { cn } from '@/utilities/cn'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-11 w-full min-w-0 rounded-full border-2 border-ink/15 bg-foam px-4 text-base text-ink transition-colors outline-none',
        'placeholder:text-ink/40 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus:border-ink focus-visible:border-ink',
        'aria-invalid:border-punch',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
